import { ChildrenStoreData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";
import { API_PART_URL } from "src/shared/config/src";

export const getBookingURL = async ({ child }: { child: ChildrenStoreData, }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;

    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/child/${child.childId}/bookings-url`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};